module.exports = {
	"new": [
		{
			"name": "Pizza bianca al prosciutto di cinghiale",
			"ingredients": "mozzarella, jambon de sanglier et poivre",
			"price": "27.-"
		}
	],
	"pizzas": [
		{
			"name": "Focaccia",
			"ingredients": "huile d’olive, ail et romarin",
			"price": "13.-"
		},
		{
			"name": "Calzone nutella",
			"ingredients": "nutella (pour deux personnes)",
			"price": "14.-"
		},
		{
			"name": "Margherita",
			"ingredients": "sauce tomate et mozzarella",
			"price": "17.-"
		},
		{
			"name": "Prosciutto",
			"ingredients": "sauce tomate, mozzarella et jambon",
			"price": "19.-"
		},
		{
			"name": "Napoli",
			"ingredients": "sauce tomate, mozzarella, câpres, anchois et olives",
			"price": "20.-"
		},
		{
			"name": "Leccese",
			"ingredients": "sauce tomate, mozzarella, lard, câpres et oignons",
			"price": "20.-"
		},
		{
			"name": "Hawaii",
			"ingredients": "sauce tomate, mozzarella, jambon et ananas",
			"price": "20.-"
		},
		{
			"name": "Merguez",
			"ingredients": "sauce tomate, mozzarella, merguez",
			"price": "20.50"
		},
		{
			"name": "Calzone",
			"ingredients": "sauce tomate, mozzarella, jambon et oeuf",
			"price": "21.-"
		},
		{
			"name": "Parigi",
			"ingredients": "sauce tomate, mozzarella, jambon et champignons de Paris",
			"price": "21.-"
		},
		{
			"name": "Diavola",
			"ingredients": "sauce tomate, mozzarella, salami piquant",
			"price": "21.-"
		},
		{
			"name": "Cacciatora",
			"ingredients": "sauce tomate, mozzarella, lard et chanterelles",
			"price": "21.-"
		},
		{
			"name": "Ai gamberetti",
			"ingredients": "sauce tomate, mozzarella, crevettes, ail et basilic",
			"price": "21.-"
		},
		{
			"name": "Romana",
			"ingredients": "sauce tomate, mozzarella, jambon, champignons et oeuf",
			"price": "21.50"
		},
		{
			"name": "Paesana",
			"ingredients": "sauce tomate, mozzarella, merguez, poivrons et oignons",
			"price": "22.-"
		},
		{
			"name": "Tunisina",
			"ingredients": "sauce tomate, mozzarella, merguez et salami piquant",
			"price": "22.-"
		},
		{
			"name": "4 Formaggi",
			"ingredients": "sauce tomate, mozzarella, gruyère, gorgonzola et pecorino",
			"price": "22.-"
		},
		{
			"name": "Tonella",
			"ingredients": "sauce tomate, mozzarella, thon, oeuf et oignons",
			"price": "22.-"
		},
		{
			"name": "Indiana",
			"ingredients": "sauce tomate, mozzarella, poulet et sauce au curry",
			"price": "22.-"
		},
		{
			"name": "Capricciosa",
			"ingredients": "sauce tomate, mozzarella, jambon, salami piquant, olives et poivrons",
			"price": "22.50"
		},
		{
			"name": "4 Stagioni",
			"ingredients": "sauce tomate, mozzarella, jambon, poivrons, artichauts et champignons",
			"price": "23.-"
		},
		{
			"name": "Caprese",
			"ingredients": "sauce tomate, mozzarella, mozzarella di bufala, petites tomates et basilic",
			"price": "23.-"
		},
		{
			"name": "Carciofara",
			"ingredients": "mozzarella, pecorino, artichauts frais et petites tomates",
			"price": "23.-"
		},
		{
			"name": "Forestiera",
			"ingredients": "sauce tomate, mozzarella, mélange de champignons frais",
			"price": "23.-"
		},
		{
			"name": "Vegetariana",
			"ingredients": "sauce tomate, mozzarella, aubergines, courgettes, olives et poivrons rôtis",
			"price": "23.-"
		},
		{
			"name": "Alla Pizzetta",
			"ingredients": "sauce tomate, mozzarella, jambon, salami piquant, merguez, champignons, poivrons et olives",
			"price": "24.-"
		},
		{
			"name": "Ai gamberi",
			"ingredients": "sauce tomate, mozzarella, gambas (crevette géante), ail et basilic",
			"price": "24.-"
		},
		{
			"name": "Contadina",
			"ingredients": "sauce tomate, provola fumée, saucisse maison, épinards et oignons rouges",
			"price": "24.-"
		},
		{
			"name": "Grand-Rue",
			"ingredients": "sauce tomate, mozzarella, viande de veau, champignons et café de Paris",
			"price": "24.-"
		},
		{
			"name": "Parma",
			"ingredients": "sauce tomate, mozzarella et jambon de Parme",
			"price": "24.-"
		},
		{
			"name": "Talenzana",
			"ingredients": "crème, mozzarella, taleggio, aubergines et tomates fraîches",
			"price": "24.-"
		},
		{
			"name": "Ai frutti di mare",
			"ingredients": "sauce tomate, mozzarella, calamars, moules, vongoles, crevettes, poulpe et ail",
			"price": "25.-"
		},
		{
			"name": "Balsamica",
			"ingredients": "sauce tomate, mozzarella, rucola, mozzarella di bufala et crème de balsamique",
			"price": "25.-"
		},
		{
			"name": "Valtellinese",
			"ingredients": "sauce tomate, mozzarella, taleggio et bresaola",
			"price": "25.-"
		},
		{
			"name": "Blanche au saumon fumé",
			"ingredients": "mozzarella, ricotta et saumon fumé du fumoir de Chailly",
			"price": "27.-"
		},
		{
			"name": "I mortacci",
			"ingredients": "crème, mozzarella, mortadella IGP, burrata et crème de pistaches de Bronte DOP",
			"price": "27.-"
		},
		{
			"name": "Primavera",
			"ingredients": "sauce tomate, mozzarella, jambon de Parme, rucola, écailles de parmesan et petites tomates",
			"price": "27.-"
		},
		{
			"name": "Andria",
			"ingredients": "sauce tomate, mozzarella, bresaola, burrata, rucola et olives taggiasche",
			"price": "28.-"
		}
	],
	"bruschette": [
		{
			"name": "Bruschetta ai pomodori",
			"ingredients": "tranches de pain avec tomates, ail, basilic et huile d’olive",
			"price": "13.-"
		},
		{
			"name": "Bruschetta verde",
			"ingredients": "tranches de pain avec cornichons, ail, câpres et anchois",
			"price": "13.-"
		}
	],
	"pates": [
		{
			"name": "Napoli",
			"ingredients": "sauce tomate, ail et basilic",
			"price": "20.-"
		},
		{
			"name": "Aglio, olio e peperoncino",
			"ingredients": "ail, huile d’olive et piments",
			"price": "20.-"
		},
		{
			"name": "Al tonno",
			"ingredients": "sauce tomate, thon, oignons et basilic",
			"price": "21.-"
		},
		{
			"name": "Ai carciofi",
			"ingredients": "artichauts frais, tomates fraîches et écailles de parmesan",
			"price": "21.-"
		},
		{
			"name": "All’amatriciana",
			"ingredients": "sauce tomate, lard et oignons",
			"price": "21.-"
		},
		{
			"name": "All’arrabbiata",
			"ingredients": "sauce tomate, olives, piments, ail et persil",
			"price": "21.-"
		},
		{
			"name": "Al gorgonzola",
			"ingredients": "sauce tomate, crème et gorgonzola",
			"price": "21.-"
		},
		{
			"name": "Bolognese",
			"ingredients": "sauce tomate et viande de boeuf",
			"price": "22.-"
		},
		{
			"name": "Ai porcini",
			"ingredients": "crème, jambon et bolets",
			"price": "22.-"
		},
		{
			"name": "Alle melanzane",
			"ingredients": "sauce tomate, aubergines, mozzarella di bufala et basilic",
			"price": "22.-"
		},
		{
			"name": "Diavola",
			"ingredients": "sauce tomate, salami piquant, ail et piments",
			"price": "22.-"
		},
		{
			"name": "Prosciutto e zafferano",
			"ingredients": "crème, jambon et safran",
			"price": "22.-"
		},
		{
			"name": "Puttanesca",
			"ingredients": "sauce tomate, câpres, anchois, olives, ail et piments",
			"price": "22.-"
		},
		{
			"name": "Carbonara",
			"ingredients": "crème, lard et oeuf",
			"price": "22.-"
		},
		{
			"name": "Al pollo",
			"ingredients": "crème, poulet et sauce tomate",
			"price": "23.-"
		},
		{
			"name": "Alle spugnole",
			"ingredients": "crème et morilles",
			"price": "25.-"
		},
		{
			"name": "Linguine alle vongole veraci *",
			"ingredients": "Vongole veraci, tomates fraîches, ail, piment et persil (* selon arrivage)",
			"price": "25.-"
		},
		{
			"name": "Al salmone affumicato",
			"ingredients": "sauce tomate, crème et saumon fumé du fumoir de Chailly",
			"price": "26.-"
		},
		{
			"name": "Ai frutti di mare",
			"ingredients": "sauce tomate, calamars, moules, vongoles, crevettes et poulpe",
			"price": "27.-"
		}
	],
	"patesmaison": [
		{
			"name": "Cannelloni ricotta e spinaci",
			"ingredients": "sauce tomate, ricotta, épinards et fromage râpé",
			"price": "21.-"
		},
		{
			"name": "Gnocchi",
			"ingredients": "sauce tomate, mozzarella di bufala et basilic",
			"price": "22.-"
		},
		{
			"name": "Cannelloni di carne",
			"ingredients": "sauce tomate, viande de veau et fromage râpé",
			"price": "23.-"
		}
	],
	"risottos": [
		{
			"name": "Alla Milanese",
			"ingredients": "safran et fromage râpé",
			"price": "24.-"
		},
		{
			"name": "Ai carciofi",
			"ingredients": "artichauts frais et fromage râpé",
			"price": "26.-"
		},
		{
			"name": "Ai porcini",
			"ingredients": "bolets et fromage râpé",
			"price": "26.-"
		},
		{
			"name": "Al prosecco",
			"ingredients": "vin prosecco et fromage râpé",
			"price": "26.-"
		},
		{
			"name": "Ai gamberi",
			"ingredients": "gambas, roquette, petites tomates et fromage râpé",
			"price": "28.-"
		}
	],
	"salades": [
		{
			"name": "Insalata mista",
			"ingredients": "laitue iceberg, carottes, céleri-pomme, petites tomates et oignons ",
			"hprice": "7.-",
			"price": "10.-"
		},
		{
			"name": "Insalata Caprese",
			"ingredients": "tomates, mozzarella di bufala et basilic",
			"hprice": "10.-",
			"price": "17.-"
		},
		{
			"name": "Insalata di rucola",
			"ingredients": "roquette, petites tomates, écailles de parmesan et oignons",
			"hprice": "10.-",
			"price": "17.-"
		},
		{
			"name": "Insalata di pollo",
			"ingredients": "laitue iceberg, poulet, maïs, poivrons rôtis et oignons",
			"hprice": "11.-",
			"price": "18.-"
		}
	],
	"desserts": [
		{
			"name": "Tiramisù fait maison",
			"price": "8.-"
		},
		{
			"name": "Panna cotta fait maison",
			"price": "6.-"
		},
		{
			"name": "Flan caramel fait maison",
			"price": "6.-"
		},
		{
			"name": "Boule de glace (Vanille / Fiordilatte / Stracciatella / Pistache / Noisette)",
			"price": "4.-"
		}
	],
	"boissons": {
		"dl": [
			{
				"name": "Valser Classic / Silence / Limelite",
				"price": "3.-"
			},
			{
				"name": "FuseTea Lemon / Peach / Green tea",
				"price": "3.50"
			},
			{
				"name": "Coca-Cola / Zero",
				"price": "3.50"
			},
			{
				"name": "Fanta / Mango",
				"price": "3.50"
			},
			{
				"name": "Sprite",
				"price": "3.50"
			}
		],
		"cl": [
			{
				"name": "Sanpellegrino Limonata / Aranciata / Aranciata amara / Chinotto",
				"price": "3.50"
			}
		],
		"l": [
			{
				"name": "Valser Classic / Silence",
				"price": "5.-"
			},
			{
				"name": "Coca-Cola",
				"price": "6.-"
			},
			{
				"name": "FuseTea Peach",
				"price": "6.-"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/menu.json
// module id = 2
// module chunks = 0